import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { SezioneProveScritte } from '../../../models/sezioni/sezione-prove-scritte';

import { ProveScritteAddFormComponent } from './prove-scritte-add-form.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [modale_aggiungi_prova_scritta]',
  templateUrl: 'prova-scritta-mod-add.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class ProvaScrittaModAddComponent {
  @Output() onReturn: EventEmitter<SezioneProveScritte> = new EventEmitter<SezioneProveScritte>();
  @ViewChild('formProvaScritta') formProvaScritta: ProveScritteAddFormComponent;

  inizializza(urlAddProvaScritta: string, idSezione: string, idFascicolo: string) {
    openModal('modaleAddProvaScritta');
    this.formProvaScritta.inizializza(urlAddProvaScritta, idSezione, idFascicolo);

  }

  createForm() {
    this.formProvaScritta.createForm();
  }

  manageModal(sezione: SezioneProveScritte) {
    if (sezione) {
      closeModal('modaleAddProvaScritta');
      this.onReturn.emit(sezione);
    }
  }
}
